module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/IP Camera.1f6c2985.png";